export const AVATAR_TYPES = {
  ICON: 'icon',
  EMOJI: 'emoji',
};

export const AVATAR_ICON_OPTIONS = [
  {
    id: 'headphones',
    type: AVATAR_TYPES.ICON,
    icon: 'headphones',
    label: 'Headphones',
    backgroundColor: '#111827',
    color: '#22d3ee',
  },
  {
    id: 'microphone',
    type: AVATAR_TYPES.ICON,
    icon: 'microphone-variant',
    label: 'Microphone',
    backgroundColor: '#1f2937',
    color: '#facc15',
  },
  {
    id: 'record',
    type: AVATAR_TYPES.ICON,
    icon: 'record-player',
    label: 'Record Player',
    backgroundColor: '#312e81',
    color: '#f472b6',
  },
  {
    id: 'radio',
    type: AVATAR_TYPES.ICON,
    icon: 'radio',
    label: 'Radio',
    backgroundColor: '#0f172a',
    color: '#38bdf8',
  },
  {
    id: 'album',
    type: AVATAR_TYPES.ICON,
    icon: 'album',
    label: 'Album',
    backgroundColor: '#292524',
    color: '#fde047',
  },
  {
    id: 'guitar',
    type: AVATAR_TYPES.ICON,
    icon: 'guitar-electric',
    label: 'Guitar',
    backgroundColor: '#4a044e',
    color: '#f472b6',
  },
  {
    id: 'drum',
    type: AVATAR_TYPES.ICON,
    icon: 'drum',
    label: 'Drum',
    backgroundColor: '#1d4ed8',
    color: '#f9fafb',
  },
  {
    id: 'note',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note',
    label: 'Music Note',
    backgroundColor: '#065f46',
    color: '#bbf7d0',
  },
  {
    id: 'circle',
    type: AVATAR_TYPES.ICON,
    icon: 'music-circle',
    label: 'Music Circle',
    backgroundColor: '#581c87',
    color: '#fde68a',
  },
  {
    id: 'clef',
    type: AVATAR_TYPES.ICON,
    icon: 'music-clef-treble',
    label: 'Treble Clef',
    backgroundColor: '#0c4a6e',
    color: '#93c5fd',
  },
  {
    id: 'rest',
    type: AVATAR_TYPES.ICON,
    icon: 'music-rest-whole',
    label: 'Music Rest',
    backgroundColor: '#1f2937',
    color: '#fef08a',
  },
  {
    id: 'disc',
    type: AVATAR_TYPES.ICON,
    icon: 'disc',
    label: 'Disc',
    backgroundColor: '#111827',
    color: '#f87171',
  },
  {
    id: 'equalizer',
    type: AVATAR_TYPES.ICON,
    icon: 'equalizer',
    label: 'Equalizer',
    backgroundColor: '#7c2d12',
    color: '#fed7aa',
  },
  {
    id: 'metronome',
    type: AVATAR_TYPES.ICON,
    icon: 'metronome',
    label: 'Metronome',
    backgroundColor: '#312e81',
    color: '#c7d2fe',
  },
  {
    id: 'cassette',
    type: AVATAR_TYPES.ICON,
    icon: 'cassette',
    label: 'Cassette',
    backgroundColor: '#3f3f46',
    color: '#f4f4f5',
  },
  {
    id: 'boombox',
    type: AVATAR_TYPES.ICON,
    icon: 'boombox',
    label: 'Boombox',
    backgroundColor: '#0f766e',
    color: '#99f6e4',
  },
  {
    id: 'tune',
    type: AVATAR_TYPES.ICON,
    icon: 'tune-vertical',
    label: 'Tune',
    backgroundColor: '#9333ea',
    color: '#fbcfe8',
  },
  {
    id: 'rocket',
    type: AVATAR_TYPES.ICON,
    icon: 'rocket-launch',
    label: 'Rocket',
    backgroundColor: '#1d4ed8',
    color: '#bfdbfe',
  },
  {
    id: 'star',
    type: AVATAR_TYPES.ICON,
    icon: 'star-four-points',
    label: 'Star',
    backgroundColor: '#ca8a04',
    color: '#fef3c7',
  },
  {
    id: 'fire',
    type: AVATAR_TYPES.ICON,
    icon: 'fire',
    label: 'Fire',
    backgroundColor: '#b91c1c',
    color: '#fee2e2',
  },
  {
    id: 'turntable',
    type: AVATAR_TYPES.ICON,
    icon: 'turntable',
    label: 'Turntable',
    backgroundColor: '#111827',
    color: '#fbbf24',
  },
  {
    id: 'lightning',
    type: AVATAR_TYPES.ICON,
    icon: 'lightning-bolt',
    label: 'Lightning',
    backgroundColor: '#0f172a',
    color: '#fde047',
  },
  {
    id: 'waveform',
    type: AVATAR_TYPES.ICON,
    icon: 'waveform',
    label: 'Waveform',
    backgroundColor: '#4c1d95',
    color: '#c084fc',
  },
  {
    id: 'music-box',
    type: AVATAR_TYPES.ICON,
    icon: 'music-box',
    label: 'Music Box',
    backgroundColor: '#065f46',
    color: '#d1fae5',
  },
  {
    id: 'play',
    type: AVATAR_TYPES.ICON,
    icon: 'play-circle',
    label: 'Play Button',
    backgroundColor: '#1e293b',
    color: '#f8fafc',
  },
  {
    id: 'music-note-plus',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-plus',
    label: 'Note Plus',
    backgroundColor: '#7f1d1d',
    color: '#fecaca',
  },
  {
    id: 'music-note-off',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-off',
    label: 'Note Off',
    backgroundColor: '#1f2937',
    color: '#9ca3af',
  },
  {
    id: 'music-note-eighth',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-eighth',
    label: 'Eighth Note',
    backgroundColor: '#581c87',
    color: '#f5d0fe',
  },
  {
    id: 'music-note-sixteenth',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-sixteenth',
    label: 'Sixteenth Note',
    backgroundColor: '#0369a1',
    color: '#bae6fd',
  },
  {
    id: 'music-note-half',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-half',
    label: 'Half Note',
    backgroundColor: '#14532d',
    color: '#bbf7d0',
  },
  {
    id: 'music-note-quarter',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-quarter',
    label: 'Quarter Note',
    backgroundColor: '#854d0e',
    color: '#fde68a',
  },
  {
    id: 'music-note-whole',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-whole',
    label: 'Whole Note',
    backgroundColor: '#134e4a',
    color: '#ccfbf1',
  },
  {
    id: 'music-note-multiple',
    type: AVATAR_TYPES.ICON,
    icon: 'music-note-multiple',
    label: 'Multiple Notes',
    backgroundColor: '#312e81',
    color: '#a5b4fc',
  },
  {
    id: 'music-outline',
    type: AVATAR_TYPES.ICON,
    icon: 'music-circle-outline',
    label: 'Music Circle Outline',
    backgroundColor: '#4a044e',
    color: '#f5d0fe',
  },
  {
    id: 'karate',
    type: AVATAR_TYPES.ICON,
    icon: 'karate',
    label: 'Karate Move',
    backgroundColor: '#1f2937',
    color: '#f97316',
  },
  {
    id: 'emoticon-cool',
    type: AVATAR_TYPES.ICON,
    icon: 'emoticon-cool-outline',
    label: 'Cool',
    backgroundColor: '#111827',
    color: '#38bdf8',
  },
  {
    id: 'gamepad',
    type: AVATAR_TYPES.ICON,
    icon: 'gamepad-variant',
    label: 'Gamepad',
    backgroundColor: '#0f172a',
    color: '#facc15',
  },
  {
    id: 'controller',
    type: AVATAR_TYPES.ICON,
    icon: 'controller-classic',
    label: 'Controller',
    backgroundColor: '#1e293b',
    color: '#f97316',
  },
  {
    id: 'vr',
    type: AVATAR_TYPES.ICON,
    icon: 'virtual-reality',
    label: 'VR Goggles',
    backgroundColor: '#312e81',
    color: '#fbbf24',
  },
  {
    id: 'robot',
    type: AVATAR_TYPES.ICON,
    icon: 'robot-excited-outline',
    label: 'Robot',
    backgroundColor: '#0f172a',
    color: '#22d3ee',
  },
  {
    id: 'rocket-outline',
    type: AVATAR_TYPES.ICON,
    icon: 'rocket-launch-outline',
    label: 'Rocket Outline',
    backgroundColor: '#1f2937',
    color: '#a855f7',
  },
  {
    id: 'piano',
    type: AVATAR_TYPES.ICON,
    icon: 'piano',
    label: 'Piano',
    backgroundColor: '#111827',
    color: '#f9fafb',
  },
  {
    id: 'violin',
    type: AVATAR_TYPES.ICON,
    icon: 'violin',
    label: 'Violin',
    backgroundColor: '#451a03',
    color: '#facc15',
  },
];

const DEFAULT_OPTION = AVATAR_ICON_OPTIONS[0];

export function getAvatarOptionById(id) {
  if (!id) {
    return { ...DEFAULT_OPTION };
  }
  // Bot'lardan gelen value değerleri (örn: 'music-note', 'microphone-variant') icon ile eşleşmeli
  const found =
    AVATAR_ICON_OPTIONS.find(option => 
      option.id === id || 
      option.icon === id ||
      option.icon === id.replace('_', '-') // Fallback: underscore yerine dash
    ) || DEFAULT_OPTION;
  return { ...found };
}

export const DEFAULT_AVATAR_OPTION = getAvatarOptionById(DEFAULT_OPTION.id);

export function normalizeAvatar(avatar) {
  if (!avatar) {
    return { ...DEFAULT_AVATAR_OPTION };
  }

  if (typeof avatar === 'string') {
    if (avatar.startsWith('icon:')) {
      const optionId = avatar.substring(5);
      return getAvatarOptionById(optionId);
    }
    return {
      type: AVATAR_TYPES.EMOJI,
      value: avatar,
    };
  }

  if (avatar.type === AVATAR_TYPES.ICON || avatar.type === 'ICON') {
    if (avatar.id) {
      return getAvatarOptionById(avatar.id);
    }
    if (avatar.icon) {
      return getAvatarOptionById(avatar.icon);
    }
    // Bot'lardan gelen avatar'lar value ile geliyor: { type: 'ICON', value: 'music-note' }
    if (avatar.value) {
      return getAvatarOptionById(avatar.value);
    }
    return { ...DEFAULT_AVATAR_OPTION };
  }

  if (avatar.type === AVATAR_TYPES.EMOJI) {
    return {
      type: AVATAR_TYPES.EMOJI,
      value: avatar.value || '🎧',
    };
  }

  return { ...DEFAULT_AVATAR_OPTION };
}

